<template>
	<div>
		<v-toolbar class="mt-6" flat color="transparent">
			<v-img :src="tenant.settings.brandImages.headerLogos.auth.light" contain class="align-left" max-width="300" />
			<v-spacer></v-spacer>
			<v-toolbar-title class="hidden-sm-and-down" flat>
				<router-link v-if="$route.name === 'SignIn' || $route.name === 'Login'" to="/signup" style="text-decoration: none">
					<v-btn class="white--text text-none" outlined large>Sign Up</v-btn>
				</router-link>
			</v-toolbar-title>
		</v-toolbar>

		<v-row class="align-center justify-center mb-10 mt-5">
			<v-col cols="12" sm="12" md="4" class="pa-2 mt-5">
				<a
					v-if="hasLeftAdvert"
					:href="tenant.settings.brandAdvert.left.url"
					class="justify-center ad-image text-center"
					target="_blank"
					rel="noopener noreferrer"
					@click="onAdvertClick('left', $event)"
				>
					<v-img :src="tenant.settings.brandAdvert.left.image" />
				</a>
			</v-col>
			<v-col cols="12" sm="12" md="4">
				<v-content>
					<v-container class="fill-height" fluid>
						<slot />
					</v-container>
				</v-content>
			</v-col>
			<v-col cols="12" sm="12" md="4" class="pa-2 mt-5 mb-5">
				<a
					v-if="hasRightAdvert"
					:href="tenant.settings.brandAdvert.right.url"
					class="justify-center ad-image text-center"
					target="_blank"
					rel="noopener noreferrer"
					@click="onAdvertClick('right', $event)"
				>
					<v-img :src="tenant.settings.brandAdvert.right.image" />
				</a>
			</v-col>
		</v-row>

		<v-footer absolute flat color="transparent">
			<v-col class="text-center white--text" cols="12"
				>© <strong>{{ tenant.settings.brandName }}</strong> {{ new Date().getFullYear() }}</v-col
			>
		</v-footer>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Tracking } from '@/utils/tracking';
import { Gtm } from '@/utils/gtm';

export default {
	name: 'LoginOrSignupLayout',
	components: {},
	data: () => ({}),
	computed: {
		...mapGetters('tenant', ['tenant']),
		hasLeftAdvert() {
			return Boolean(this.tenant.settings.brandAdvert.left.image);
		},
		hasRightAdvert() {
			return Boolean(this.tenant.settings.brandAdvert.right.image);
		},
		advertMetaBase() {
			return {
				tenantId: this.tenant.tenantId,
				brandName: this.tenant.settings.brandName,
				pageRoute: this.$route && this.$route.name ? this.$route.name : '',
			};
		},
	},

	mounted() {
		Tracking.track('DisplaySignup', {});
		this.trackAdvertImpressions();
	},

	methods: {
		trackAdvertImpressions() {
			if (this.hasLeftAdvert) {
				Gtm.trackAdvertorialImpression('left', {
					...this.advertMetaBase,
					adUrl: this.tenant.settings.brandAdvert.left.url,
				});
			}
			if (this.hasRightAdvert) {
				Gtm.trackAdvertorialImpression('right', {
					...this.advertMetaBase,
					adUrl: this.tenant.settings.brandAdvert.right.url,
				});
			}
		},

		onAdvertClick(side, event) {
			const advert = this.tenant.settings.brandAdvert[side];
			Gtm.trackAdvertorialClick(side, {
				...this.advertMetaBase,
				adUrl: advert.url,
			});
			// Allow default navigation (target=_blank) after the dataLayer push.
			if (!advert.url) {
				event.preventDefault();
			}
		},
	},
};
</script>

<style scoped>
.ad-image {
	width: 90%;
	height: 90%;
	display: flex;
	margin: auto;
}
</style>
